import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import { AdminProvider } from "./context/AdminContext";

function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <AdminProvider>
        <BrowserRouter basename={__BASE_PATH__}>
          <AppRoutes />
        </BrowserRouter>
      </AdminProvider>
    </I18nextProvider>
  );
}

export default App;